module.exports = __webpack_public_path__ + "img/codeSnippetinvalid.5c352912.svg";